














































































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      valid: false,
      filters: {
        nihii: undefined,
        cbe: undefined,
        ssin: undefined,
        state: [],
        period: undefined,
        iban: undefined,
        cashingDateFrom: undefined,
        cashingDateTo: undefined,
      },
      delay: undefined as any,
    };
  },
  watch: {
    filters: {
      handler(filters) {
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.$emit("updateFilters", filters);
        }, 500);
      },
      deep: true,
    },
  },
});
